import React, { useState, useEffect } from "react";
import {
  token,
  url,
  is_superuser,
  acts_for_franchise,
  picked_franchise_id,
  is_back_office,
  has_franchise_reach,
  is_franchise_admin,
  is_franchise_staff,
  is_staff_only,
  is_shop_admin,
  is_shop_manager,
} from "../../Functionalities/Config";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import "./settings.css";
import { showMessage } from "../../Functionalities/Functions";
import ModalComponent from "../../CoreComponents/ModalComponent";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import {
  resolveDataType,
  validateSettingValue,
  validateWithSettingsExcludeList,
  limitSettingsForStaffOnPage,
  limitSettingsForFranchiseUsers,
} from "./Function";
import { useLocation, useParams } from "react-router-dom";
import RiderAlertCard from "./RiderAlertCard";
import StaticOtpCard from "./StaticOtpCard";
import { settingLabel } from "./settingLabel";

const SEES_CONTACT_TABS = is_superuser === true || is_franchise_admin === true || is_franchise_staff === true;
const SEES_CHARGE_TAB = acts_for_franchise || is_franchise_admin === true || is_franchise_staff === true;

const settingsTab = (title, iconClass, shown = true) => ({
  title: shown && title,
  icon: shown && <i className={`fa ${iconClass} font-18 align-middle `} />,
});

const Body = ({ restaurant_id, franchiseSide }) => {
  const [settingsdata, setSettingsdata] = useState([]);
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const [data_type, setDataType] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeId, setActiveId] = useState(0);
  const [activeTitle, setActiveTitle] = useState("");
  const [param_name, setParamName] = useState("");

  const settingsTitles = [
    settingsTab("all", "fa-home"),
    settingsTab("order", "fa-shopping-cart"),
    settingsTab("contact", "fa-address-book", SEES_CONTACT_TABS),
    settingsTab("delivery", "fa-truck", SEES_CONTACT_TABS),
    settingsTab("charge", "fa-money", SEES_CHARGE_TAB),
  ];

  const excludedSettings = ["express_delivery_charge"];

  // A superuser opens a franchise by id; franchise users edit their own. Branch users never see it.
  const showRiderAlert = franchiseSide
    ? Boolean(restaurant_id)
    : !restaurant_id && has_franchise_reach;

  useEffect(() => {
    fetchAllData();
  }, [restaurant_id]);

  const fetchAllData = () => {
    const axios = require("axios");
    let url1 = "";

    if (restaurant_id) {
      if (franchiseSide) {
        url1 = `/configurations/franchise/?page_wise=0&franchise_list=[${restaurant_id}]`;
      } else {
        url1 = "/configurations/?page_wise=0&branch_id=" + restaurant_id;
      }
    } else {
      url1 = "/configurations/?page_wise=0";

      if (is_superuser) {
        url1 = "/configurations/admin/?page_wise=0";
      }
      if (has_franchise_reach) {
        url1 = "/configurations/franchise/?page_wise=0";
      }
    }

    const config = {
      method: "get",
      url: url + url1,
      headers: {
        Authorization: token,
      },
    };

    axios(config)
      .then((response) => {
        const settingsToShow = validateWithSettingsExcludeList(
          response.data,
          excludedSettings
        );
        setSettingsdata(
          limitSettingsForStaffOnPage(
            limitSettingsForFranchiseUsers(settingsToShow, is_superuser),
            is_staff_only,
            restaurant_id
          )
        );
        setLoading(false);
        clear();
      })
      .catch(() => {
        // Without this the page spins forever when the fetch fails.
        setLoading(false);
      });
  };

  const responseHandler = (response) => {
    if (response.data.Status) {
      showMessage(
        response.data.Message,
        "success",
        "Success!",
        "top",
        "top-right",
        0
      );
    } else {
      showMessage(
        response.data.Error,
        "danger",
        "Error!",
        "top",
        "top-right",
        0
      );
    }
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const clear = () => {
    setEdit(false);
    setName("");
    setValue("");
    setDataType("");
  };

  const handleEdit = (data) => {
    setEdit(true);
    setName(data.data.param_name);
    setValue(data.data.param_value);
    setDataType(resolveDataType(data.data));
    setParamName(data.data.param_name);
  };

  const editData = () => {

    const validationError = validateSettingValue({ name, value, data_type });
    if (validationError) {
      showMessage(validationError, "danger", "Error!", "top", "top-right", 0);
      return;
    }

    const axios = require("axios");
    const FormData = require("form-data");
    const fdata = new FormData();

    if (name === "delivery_radius") {
      if (is_superuser) {
        fdata.append("param_name", name);
        fdata.append("new_param_value", value);
      } else {
        showMessage(
          "You have no privillage to edit this",
          "danger",
          "Error!",
          "top",
          "top-right",
          0
        );
        return;
      }
    } else {
      fdata.append("param_name", name);
      fdata.append("new_param_value", value);
    }

    if (restaurant_id) {
      if (franchiseSide) {
        fdata.append("franchise_id", restaurant_id);
      } else {
        fdata.append("branch_id", restaurant_id);
      }
    }

    let url1 = "";

    if (restaurant_id) {
      if (franchiseSide) {
        url1 =
          `/configurations/franchise/?page_wise=0&franchise_id=` +
          restaurant_id;
      } else {
        url1 = "/configurations/?page_wise=0&branch_id=" + restaurant_id;
      }
    } else {
      url1 = "/configurations/?page_wise=0";
      if (is_superuser) {
        url1 = "/configurations/admin/?page_wise=0";
      }
      if (has_franchise_reach) {
        url1 = "/configurations/franchise/?page_wise=0";
      }
    }


    const config = {
      method: "put",
      url: url + url1,
      headers: {
        Authorization: token,
      },
      data: fdata,
    };


    if (name === "delivery_radius" && !is_superuser) {
      return;
    }

    axios(config)
      .then((response) => {
        responseHandler(response);
        fetchAllData();
      })
      .catch((error) => {
        // A rejected save used to be swallowed here, so the control simply
        // refused to move with no explanation.
        showMessage(
          error?.response?.data?.Error || "Could not save this setting",
          "danger",
          "Error!",
          "top",
          "top-right",
          0
        );
      });
  };

  const tConvert = (time) => {
    const ts = time;
    let H = +ts.substr(0, 2);
    let h = H % 12 || 12;
    h = h < 10 ? "0" + h : h;
    const ampm = H < 12 ? " AM" : " PM";
    return h + ts.substr(2, 3) + ampm;
  };

  const onActive = (index, title) => {
    setActiveId(index);
    setActiveTitle(title);
  };

  return (
    <div className="content-body" style={{ minHeight: 1100 }}>
      {!loading ? (
        <div className="container-fluid">
          {showRiderAlert && (
            <RiderAlertCard franchiseId={franchiseSide ? restaurant_id : null} />
          )}
          {is_superuser && !restaurant_id && <StaticOtpCard />}
          <div className="row">
            <ModalComponent
              heading={"Edit " + settingLabel(name)}
              primaryButton={(e) => {
                e.preventDefault();
              }}
              primaryButtonName={"Cancel"}
              secondaryButton={(e) => {
                editData();
                e.preventDefault();
              }}
              secondaryButtonName={"Save"}
              centerBottonButton={true}
            >
              <div className="table-responsive">
                {!edit && (
                  <p className="card-header text-lg  bg-transparent">
                    <b>Choose edit</b>
                  </p>
                )}
                <br />
                <div className="form-group">
                  <div className="input-group input-group-alternative justify-content-center">
                    {edit ? (
                      name === "open" ? (
                        <>
                          <label className="radio-inline mx-4">
                            <input
                              type="radio"
                              value={"true"}
                              checked={value === "true" && value}
                              name="optradio"
                              onChange={onChange}
                              className="form-control"
                              id="users-list-role"
                            />
                            Yes
                          </label>
                          <label className="radio-inline mx-4">
                            <input
                              type="radio"
                              value={"false"}
                              checked={value === "false" && value}
                              name="optradio"
                              onChange={onChange}
                              className="form-control"
                              id="users-list-role"
                            />
                            No
                          </label>
                        </>
                      ) : (
                        (data_type === "string" && (
                          <input
                            value={value}
                            name={name}
                            onChange={onChange}
                            className="form-control"
                            placeholder={""}
                            type="text"
                          />
                        )) ||
                        (data_type === "number" && (
                          <input
                            value={value}
                            name={name}
                            onChange={onChange}
                            className="form-control"
                            onKeyDown={(evt) =>
                              ((evt.key === "e" || evt.key === "-") &&
                                evt.preventDefault()) ||
                              (evt.key === "E" && evt.preventDefault())
                            }
                            onWheelCapture={(e) => {
                              e.target.blur();
                            }}
                            type="number"
                            inputMode="decimal"
                            min="0"
                            step="0.01"
                          />
                        )) ||
                        (data_type === "time" && (
                          <input
                            value={value}
                            name={name}
                            onChange={onChange}
                            className="form-control"
                            type="time"
                            step={2}
                          />
                        )) ||
                        (data_type === "bool" && (
                          <select
                            value={value}
                            name={name}
                            onChange={onChange}
                            className="form-control"
                            id="users-list-role"
                          >
                            <option value={"true"}>Yes</option>
                            <option value={"false"}>No</option>
                          </select>
                        )) ||
                        (data_type === "choice" && (
                          <select
                            value={value}
                            name={name}
                            onChange={onChange}
                            className="form-control"
                            id="users-list-role"
                          >
                            {param_name === "location_api_type" ? (
                              <>
                                <option value={"google"}>Google</option>
                                <option value={"geopy"}>Geopy</option>
                              </>
                            ) : param_name === "preferred_payment_gateway" ? (
                              <>
                                <option value={"phonepe"}>PhonePe</option>
                                <option value={"razorpay"}>Razorpay</option>
                              </>
                            ) : (
                              param_name === "phonepe_environment" && (
                                <>
                                  <option value={"sandbox"}>Sandbox</option>
                                  <option value={"production"}>
                                    Production
                                  </option>
                                </>
                              )
                            )}
                          </select>
                        ))
                      )
                    ) : (
                      <input
                        disabled
                        className="form-control"
                        value="Choose edit"
                        placeholder={"Choose edit"}
                        type="text"
                      />
                    )}
                  </div>
                </div>
              </div>
            </ModalComponent>

            <div className="col-lg-12">
              <div className="card">
                <div
                  className="d-sm-flex mb-lg-4 mb-2"
                  style={{ overflowX: "scroll" }}
                >
                  <div className="card-body pt-2">
                    <div className="d-flex">
                      <div
                        className="email-left-box px-0 mb-3"
                        style={{ width: "0rem" }}
                      >
                        <div className="mail-list mt-0 d-flex">
                          {settingsTitles.map((data, indexNo) => {
                            if (data.title) {
                              return (
                                <div
                                  key={indexNo}
                                  className="intro-title d-flex justify-content-between p-1 m-1"
                                >
                                  <a
                                    className="list-group-item p-1"
                                    onClick={(e) =>
                                      onActive(indexNo, data.title)
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={
                                        activeId === indexNo
                                          ? "btn btn-primary "
                                          : "btn"
                                      }
                                      style={{
                                        textTransform: "capitalize",
                                        minWidth: "10rem",
                                        textAlign: "left",
                                      }}
                                    >
                                      {data.icon}
                                      {data.title}
                                    </button>
                                  </a>
                                </div>
                              );
                            }
                            return null;
                          })}
                        </div>
                      </div>

                      <div
                        className="email-right-box ml-0 ml-sm-4 ml-sm-0 pl-0 "
                        style={{ marginTop: "5rem" }}
                      >
                        <div className="email-list mt-3">
                          {settingsdata.map((item, index) => {
                            return (
                              <div key={index}>
                                {activeId === activeId && (
                                  <>
                                    {activeTitle === "all" ? (
                                      <>
                                        <div
                                          className="pl-0"
                                          style={{
                                            padding: ".75rem 0rem",
                                            width: "25rem",
                                            height: "4rem",
                                          }}
                                          data-toggle="modal"
                                          data-target="#sendModal"
                                          onClick={() =>
                                            handleEdit({ data: item })
                                          }
                                        >
                                          <a
                                            style={{ fontWeight: "400" }}
                                            className="list-group-item  py-0"
                                          >
                                            {settingLabel(item.param_name)}
                                          </a>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {item.param_name.match(activeTitle) && (
                                          <>
                                            <div
                                              className="pl-0"
                                              style={{
                                                padding: ".75rem 0rem",
                                                width: "25rem",
                                                height: "4rem",
                                              }}
                                              data-toggle="modal"
                                              data-target="#sendModal"
                                              onClick={() =>
                                                handleEdit({ data: item })
                                              }
                                            >
                                              <a
                                                style={{
                                                  fontWeight: "400",
                                                }}
                                                className="list-group-item py-0"
                                              >
                                                {settingLabel(item.param_name)}
                                              </a>
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div
                        className="email-right-box ml-0 ml-sm-4 ml-sm-0 pl-0 "
                        style={{ marginTop: "5rem" }}
                      >
                        <div className="email-list mt-3">
                          {settingsdata.map((item, index) => {
                            return (
                              <div key={index}>
                                {activeId === activeId && (
                                  <>
                                    {activeTitle === "all" ? (
                                      <div>
                                        <div
                                          style={{
                                            padding: ".75rem 0rem",
                                            width: "25rem",
                                            height: "4rem",
                                          }}
                                          data-toggle="modal"
                                          data-target="#sendModal"
                                          onClick={() =>
                                            handleEdit({ data: item })
                                          }
                                        >
                                          {item.data_type === "bool" ? (
                                            <>
                                              <div
                                                style={{
                                                  fontWeight: "400",
                                                  padding: "0rem 0",
                                                }}
                                                className="list-group-item w-100"
                                              >
                                                {item.param_value === "true"
                                                  ? "Yes"
                                                  : "No"}
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <div
                                                style={{
                                                  fontWeight: "400",
                                                  padding: ".25rem 0",
                                                  overflowY: "scroll",
                                                  height: "55px",
                                                }}
                                                className="list-group-item w-100"
                                              >
                                                {item.param_value}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div>
                                        {item.param_name.match(activeTitle) && (
                                          <>
                                            <div
                                              style={{
                                                padding: ".75rem 0rem",
                                                width: "25rem",
                                                height: "4rem",
                                              }}
                                              data-toggle="modal"
                                              data-target="#sendModal"
                                              onClick={() =>
                                                handleEdit({ data: item })
                                              }
                                            >
                                              {item.data_type === "bool" ? (
                                                <>
                                                  <div
                                                    style={{
                                                      fontWeight: "400",
                                                      padding: ".25rem 0",
                                                    }}
                                                    className="list-group-item w-100"
                                                  >
                                                    {item.param_value === "true"
                                                      ? "Yes"
                                                      : "No"}{" "}
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div
                                                    style={{
                                                      fontWeight: "400",
                                                      padding: ".25rem 0",
                                                    }}
                                                    className="list-group-item w-100"
                                                  >
                                                    {item.param_value}
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
};

function Settings() {
  const { id } = useParams();
  const ofRestaurant = new URLSearchParams(useLocation().search).get("of") === "restaurant";
  const settingsId = id || (acts_for_franchise ? picked_franchise_id : undefined);

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Settings"} subHeading={"change all settings"} />
        <NavBar />
        <Body
          restaurant_id={(is_back_office || is_shop_admin || is_shop_manager) && settingsId}
          franchiseSide={is_superuser && !ofRestaurant}
        />
        <Footer />
      </div>
    </div>
  );
}

export default Settings;
